"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var variables_1 = require("../../../style/variables");
var layout_1 = require("../../layout");
var Divider_1 = __importDefault(require("../../Divider/Divider"));
var AppList_1 = __importDefault(require("./AppList"));
var react_2 = require("react");
var app_context_1 = require("../../../shared/context/app-context");
var styles = {
    container: react_1.css({
        width: 'fit-content',
        background: "var(" + variables_1.RootColor.White + ")",
        padding: "var(" + variables_1.Spacing.sp16 + ") var(" + variables_1.Spacing.sp20 + ")",
        border: "1px solid var(" + variables_1.BorderColor.GRAY_LIGHT_4 + ")",
        boxShadow: "var(" + variables_1.Shadow.xxl + ")",
        borderRadius: "var(" + variables_1.BorderRadius.sm + ")",
    }),
};
var AppSwitcher = function () {
    var _a = react_2.useContext(app_context_1.AppContext), apps = _a.apps, currentApp = _a.currentApp;
    var launchApps = react_2.useMemo(function () { return apps.filter(function (app) { return app.enabled && app.type !== currentApp; }); }, [currentApp, apps]);
    var discoverApps = react_2.useMemo(function () { return apps.filter(function (app) { return !app.enabled && app.type !== currentApp && !app.hidePromo; }); }, [currentApp, apps]);
    return (react_1.jsx(layout_1.Flex, { direction: "column", gap: "var(" + variables_1.Spacing.sp24 + ")", css: styles.container, "data-6si-name": "app-switcher" },
        launchApps.length ? (react_1.jsx(AppList_1.default, { title: "Launch", apps: launchApps, columns: 2 })) : null,
        launchApps.length && discoverApps.length ? (react_1.jsx(Divider_1.default, null)) : null,
        discoverApps.length ? (react_1.jsx(AppList_1.default, { title: "Discover", apps: discoverApps })) : null));
};
exports.default = AppSwitcher;
